export default __webpack_public_path__ + "static/media/logo_fr.34b8a5f1.png";